import
  React, {
  useRef
}
from 'react';

import {
  CSSTransition
} from 'react-transition-group';

import {
  Colors,
  Image,
  Images
} from 'common';

import styled from 'styled-components';

import {
  useWidget,
} from 'common/contexts';

import './modal.css';

const isOesEnVlamHost =
  typeof window !== 'undefined' &&
  (window.location.hostname.includes('oesenvlamfees') ||
    window.location.hostname.includes('oesenvlam'));

const OES_ENV_VLAM_MODAL_BACKGROUND = '#1c1717';

// Styled-components for modal backdrop and content
const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: ${props => props.isWidget ? 'flex-end' : 'center'};
  opacity: ${props => props.show ? 1 : 0};
  transition: opacity 0.3s ease-in-out;
  pointer-events: ${props => props.show ? 'all' : 'none'};
  z-index: 1000;
`;

const ModalContent = styled.div`
  background: ${props => props.backgroundColor || Colors.GreyBrownSecond};
  padding: 20px;
  border-radius: ${props => props.isWidget ? '8px 8px 0 0' : '8px'};
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease-in-out;
  transform: ${props => {
    if (props.state === 'entering' || props.state === 'entered') {
      return props.isWidget ? 'translateY(0)' : 'scale(1)';
    } else {
      return props.isWidget ? 'translateY(100%)' : 'scale(0.9)';
    }
  }};
  opacity: ${props => (props.state === 'entering' || props.state === 'entered' ? 1 : 0)};
  width: auto;
  max-width: ${props => props.isWidget ? '100%' : '90%'};
  max-height: ${props => props.isWidget ? '80vh' : 'none'};
  overflow-y: auto;
`;

const CloseContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const Modal = ({ backgroundColor, show, hideCloseButton, onClose, className, children }) => {

  const isWidget = useWidget();
  const nodeRef = useRef(null);

  const resolvedBackgroundColor =
    backgroundColor !== undefined && backgroundColor !== null
      ? backgroundColor
      : isOesEnVlamHost
        ? OES_ENV_VLAM_MODAL_BACKGROUND
        : undefined;

  // NOTE: If className is provided, we don't want to use the isWidget flag, this is to center the modal on the page instead of the bottom of the screen

  return (
    <Backdrop show={show} onClick={onClose} isWidget={isWidget && !className}>
      <CSSTransition 
        in={show} 
        timeout={300} 
        classNames={className ? className : (isWidget ? 'modal-bottom' : 'modal')} 
        unmountOnExit
        nodeRef={nodeRef}
      >
        {(state) => (
          <ModalContent 
            ref={nodeRef}
            state={state}
            onClick={(e) => e.stopPropagation()} 
            isWidget={isWidget && !className}
            backgroundColor={resolvedBackgroundColor}
          >
            {!hideCloseButton && (
              <CloseContainer>
                <Image alt={'close'} src={Images.Icons.Close} width={'30px'} height={'auto'} onClick={onClose} />
              </CloseContainer>
            )}
            {children}
          </ModalContent>
        )}
      </CSSTransition>
    </Backdrop>
  );
};
